import React, {useEffect, useState, useRef} from 'react';

import Content from './Content';
import Signup from './Signup';
import Dashboard from './Dashboard';
import SpotifyGf from './SpotifyGf';
import SpotifyCallback from './SpotifyCallback';
import styles from './App.module.css';

function CursorTrail() {
  const [pos, setPos] = useState({ x: -20, y: -20 });
  const [visible, setVisible] = useState(false);
  const target = useRef({ x: -20, y: -20 });
  const raf = useRef(null);

  useEffect(() => {
    const handleMove = (e) => {
      target.current = { x: e.clientX, y: e.clientY };
      setVisible(true);
    };
    const handleLeave = () => setVisible(false);
    const animate = () => {
      setPos((prev) => {
        const dx = target.current.x - prev.x;
        const dy = target.current.y - prev.y;
        return {
          x: prev.x + dx * 0.15,
          y: prev.y + dy * 0.15,
        };
      });
      raf.current = requestAnimationFrame(animate);
    };
    raf.current = requestAnimationFrame(animate);
    document.addEventListener('mousemove', handleMove);
    document.addEventListener('mouseleave', handleLeave);
    return () => {
      document.removeEventListener('mousemove', handleMove);
      document.removeEventListener('mouseleave', handleLeave);
      if (raf.current) cancelAnimationFrame(raf.current);
    };
  }, []);

  if (!visible) return null;
  return (
    <div
      className={styles.cursorTrail}
      style={{ left: pos.x, top: pos.y }}
      aria-hidden
    />
  );
}

function calcValues() {
  const centerContent = document.getElementById('center-content');
  const centerFold = document.getElementById('center-fold');

  const overflowHeight = centerContent.clientHeight - centerFold.clientHeight;

  document.body.style.height = overflowHeight + window.innerHeight + 'px';
  const foldsContent = Array.from(
    document.querySelectorAll('[data-fold-content="true"]'),
  );
  const tick = () => {
    const scroll = -(
      document.documentElement.scrollTop || document.body.scrollTop
    );
    foldsContent.forEach(content => {
      content.style.transform = `translateY(${scroll}px)`;
    });
    requestAnimationFrame(tick);
  };

  tick();
}

function getRouteFromPath(pathname) {
  if (pathname === '/goomf/dashboard' || pathname === '/goomf/dashboard/') return 'dashboard';
  if (pathname === '/goomf' || pathname === '/goomf/') return 'signup';
  if (pathname === '/idonthaveagf/callback' || pathname === '/idonthaveagf/callback/') return 'spotifygf-callback';
  if (pathname === '/idonthaveagf' || pathname === '/idonthaveagf/') return 'spotifygf';
  return 'home';
}

function App() {
  const [route, setRoute] = useState(() => getRouteFromPath(window.location.pathname));

  useEffect(() => {
    const handlePopState = () => {
      setRoute(getRouteFromPath(window.location.pathname));
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    if (route === 'home') {
      window.addEventListener('resize', calcValues);
      calcValues();
      return () => {
        window.removeEventListener('resize', calcValues);
      };
    }
    return undefined;
  }, [route]);

  if (route === 'spotifygf-callback') {
    return (
      <div style={{ position: 'fixed', inset: 0, overflowY: 'auto' }}>
        <CursorTrail />
        <SpotifyCallback />
      </div>
    );
  }

  if (route === 'spotifygf') {
    return (
      <div style={{ position: 'fixed', inset: 0, overflowY: 'auto' }}>
        <CursorTrail />
        <SpotifyGf />
      </div>
    );
  }

  if (route === 'signup') {
    return (
      <div className={styles.all}>
        <CursorTrail />
        <Signup />
      </div>
    );
  }

  if (route === 'dashboard') {
    return (
      <div className={styles.all}>
        <CursorTrail />
        <Dashboard />
      </div>
    );
  }

  return (
    <div className={styles.all}>
      <CursorTrail />
      <div className={styles.wrapper3d}>
        <div className={`${styles.fold} ${styles.foldTop}`}>
          <div className={styles.foldAlign}>
            <div data-fold-content="true">
              <Content />
            </div>
          </div>
        </div>
        <div className={styles.fold} id="center-fold">
          <div className={styles.foldAlign}>
            <div data-fold-content="true" id="center-content">
              <Content />
            </div>
          </div>
        </div>
        <div className={`${styles.fold} ${styles.foldBottom}`}>
          <div className={styles.foldAlign}>
            <div data-fold-content="true">
              <Content />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;